'use client'

import { cn } from '@/lib/utils'
import * as React from 'react'
import { Label } from './label'
import { Input } from './input'

interface InputFieldProps extends React.ComponentProps<'input'> {
	label?: string
	subText?: string
	containerClassName?: string
}

function InputField({ className, label, subText, containerClassName, ...props }: InputFieldProps) {
	const [isHovered, setIsHovered] = React.useState(false)

	const inputElement = (
		<Input 
			className={className} 
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
			{...props} 
		/>
	)

	const inputContainer = (
		<div className="space-y-1">
			{inputElement}
			{/* Reserved space for sub-text - always present to maintain consistent height */}
			<div className="h-5 flex items-start">
				{subText && (
					<p 
						className={cn(
							"text-xs text-gray-500 transition-opacity duration-200",
							isHovered ? "opacity-100" : "opacity-0"
						)}
					>
						{subText}
					</p>
				)}
			</div>
		</div>
	)

	if (label) {
		return (
			<div className={cn("space-y-2", containerClassName)}>
				<Label>{label}</Label>
				{inputContainer}
			</div>
		)
	}

	return inputContainer
}

export { InputField }